import { Property } from "../../../../../RadObject";
import { Evaluator } from "../../../SeriouslyRAD.Framework/Evaluation/Evaluator";
import { EvaluatorPropertyValues, IEvaluator } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluator";
import { NAMESPACE } from "./_Namespace";

export type TrueEvaluatorPropertyValues =
    EvaluatorPropertyValues
    & {
    };

export type TrueEvaluatorProperties = {
    [name in keyof TrueEvaluatorPropertyValues]: Property<TrueEvaluatorPropertyValues[name]>
};

export interface ITrueEvaluator extends IEvaluator, TrueEvaluatorProperties
{
}

export class TrueEvaluator extends Evaluator<TrueEvaluatorPropertyValues> implements ITrueEvaluator
{
    public static override classNamespace = NAMESPACE + "TrueEvaluator";
    public static override className = "TrueEvaluator";

    // #region Overrides

    public override evaluate()
    {
        const
            value = true;

        this.value.set(value);

        return value;
    }

    // #endregion
}

